module.exports = __webpack_public_path__ + "static/IBMPlexSans-Light-b91539bed1d0b659e1115937b17eddaa.woff2";